const KEY_PREFIX = 'rd_user_theme_';
const isValid = (v) => v === 'light' || v === 'dark' || v === 'system';
export function getUserThemeMode(userId) {
    try {
        const stored = localStorage.getItem(KEY_PREFIX + userId);
        if (isValid(stored))
            return stored;
    }
    catch (_) {
    }
    return 'system';
}
let systemMql = null;
let systemListener = null;
function detachSystemListener() {
    if (systemMql && systemListener) {
        systemMql.removeEventListener('change', systemListener);
        systemMql = null;
        systemListener = null;
    }
}
function attachSystemListener() {
    if (!window.matchMedia)
        return;
    detachSystemListener();
    systemMql = window.matchMedia('(prefers-color-scheme: dark)');
    systemListener = (e) => {
        const navMode = e.matches ? 'dark' : 'light';
        document.dispatchEvent(new CustomEvent('rd:user-theme-changed', {
            detail: { mode: 'system' },
        }));
        document.dispatchEvent(new CustomEvent('radiant-theme:nav', {
            detail: { active: true, mode: navMode },
        }));
    };
    systemMql.addEventListener('change', systemListener);
}
export function setUserThemeMode(userId, mode) {
    try {
        localStorage.setItem(KEY_PREFIX + userId, mode);
    }
    catch (_) {
    }
    document.dispatchEvent(new CustomEvent('rd:user-theme-changed', { detail: { mode } }));
    const isDark = mode === 'dark' ||
        (mode === 'system' &&
            (window.matchMedia?.('(prefers-color-scheme: dark)').matches ??
                false));
    const navMode = isDark ? 'dark' : 'light';
    document.dispatchEvent(new CustomEvent('radiant-theme:nav', {
        detail: { active: true, mode: navMode },
    }));
    if (mode === 'system') {
        attachSystemListener();
    }
    else {
        detachSystemListener();
    }
}
//# sourceMappingURL=user-theme-utils.js.map